export type Environment = "local" | "dev" | "qas" | "prod";

function requireEnv(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(`Variável de ambiente obrigatória ausente: ${name}`);
  }
  return value;
}

const ENVIRONMENT_CONFIG = {
  local: {
    apiBaseUrl: () => requireEnv("HUB_API_BASE_URL"),
    label: "Local",
  },
  dev: {
    apiBaseUrl: () => requireEnv("HUB_API_BASE_URL_DEV"),
    label: "Development",
  },
  qas: {
    apiBaseUrl: () => requireEnv("HUB_API_BASE_URL_QAS"),
    label: "Quality Assurance",
  },
  prod: {
    apiBaseUrl: () => requireEnv("HUB_API_BASE_URL_PROD"),
    label: "Production",
  },
} as const;

export function detectEnvironment(): Environment {
  const url = window.location.href;
  if (url.includes("localhost") || url.includes("127.0.0.1")) return "local";
  if (url.includes("-dev") || url.includes(".dev.")) return "dev";
  if (url.includes("-qas") || url.includes(".qas.")) return "qas";
  return "prod";
}

export function getApiBaseUrl(env?: Environment): string {
  return ENVIRONMENT_CONFIG[env ?? detectEnvironment()].apiBaseUrl();
}

/** Definido pela PO: 3 horas de inatividade. */
const DEFAULT_IDLE_TIMEOUT_MINUTES = 180;

/**
 * Tempo de inatividade (ms) até o logout, ou `null` quando o recurso está desligado.
 * Ausente/vazio = 180 min (3 h); 0, negativo ou valor inválido desliga. É variável de build
 * (`HUB_IDLE_TIMEOUT_MINUTES`): mudar ou desligar exige novo build.
 */
export function getIdleTimeoutMs(): number | null {
  const raw = import.meta.env.HUB_IDLE_TIMEOUT_MINUTES?.trim();
  const minutes = raw ? Number(raw) : DEFAULT_IDLE_TIMEOUT_MINUTES;
  if (!Number.isFinite(minutes) || minutes <= 0) return null;
  return minutes * 60_000;
}

export function getEnvironmentLabel(env?: Environment): string {
  return ENVIRONMENT_CONFIG[env ?? detectEnvironment()].label;
}
